import { render } from "./Hospitalization.vue?vue&type=template&id=1207c186"
import script from "./Hospitalization.vue?vue&type=script&lang=js"
export * from "./Hospitalization.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__